import { useState, useEffect } from "react"
import "./ClientSelectorAlert.css"

import { Alert, Modal } from "antd"
import SearchableDropdown from "../../../components/SearchableDropdown"
import { useNavigate, useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { selectCurrentId } from "../../auth/authSlice"
import { useGetClientAndAccountsMutation } from "./crmDataApiSlice"
import { showSpinner, hideSpinner } from "../../../components/componentSlice"

const ClientSelectorAlert = ({ message, modalHeader, clientOptions, onClientSelect }) => {
    const { id } = useParams()
    const userId = useSelector(selectCurrentId)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [isClientSelectorModalOpen, setClientSelectorModalOpen] = useState(false)
    const [selectedClient, setSelectedClient] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const [getClientAndAccounts, { isLoading: isGetClientAndAccountsLoading }] = useGetClientAndAccountsMutation()

    useEffect(() => {
        if(isGetClientAndAccountsLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isGetClientAndAccountsLoading])

    const handleClientSelect = async () => {
        setErrorMessage(null)
         try {
            let request = {
                crmId: id, 
                clientId: selectedClient.clientId,
                userId: userId
            }
            const response = await getClientAndAccounts(request).unwrap()
            if(response) {
                onClientSelect(response)
                setClientSelectorModalOpen(false)
            }
        } catch(err) {
            if(err.status == 403) {
                navigate("/dash/error403")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    return(
        <div className="client-selector-alert">
            <Alert
                message={message}
                type="info" 
                showIcon 
                banner 
                action={
                    <div class="client-selector-alert-button">
                        <button type="button" onClick={() => setClientSelectorModalOpen(true)}>Select Client</button>
                    </div>
                }
            />

            <Modal open={isClientSelectorModalOpen} onCancel={() => setClientSelectorModalOpen(false)} footer={[]}>
                <div className="client-selector-alert-modal">
                    {errorMessage && 
                        <div className="error-message">
                            <p>{errorMessage}</p>
                        </div>
                    }
                    <div className='top-header'>
                        <header>{modalHeader}</header>
                    </div>
                    <div className="control-main">
                        <div className="search-dropdown">
                            <SearchableDropdown
                                options={clientOptions}
                                label="name"
                                id="id"
                                selectedVal={selectedClient ? selectedClient.firstName + " " + selectedClient.lastName : null}
                                placeholderVal={"Select Client..."}
                                handleChange={(val, id) => setSelectedClient(id)}
                            />
                        </div>
                        <div className="control-button">
                            <button onClick={() => handleClientSelect()}>Select Client</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ClientSelectorAlert